import React, {
  Component
} from 'react';
import {
    countWords
} from '../helpers/Fields';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
const $=window.$;
const jQuery=window.jQuery;

export default class Registeruserdetails extends Component {

  constructor(props) {
    super(props);
    this.state = {
     tr_student:'',
     tr_Working:'none',
     othershow:'none',
     hidOccupation:'',
     photoDisplay:'none',
     checkedGenderOption:1,
     optphotoOption:'Uploadlater',
     checkedOccupationOption:1,
     getcountrycodes:[],
     locations:[],
     cities:[]

    };
  }

  submit(){
    this.props.submit();
  }

  showPhotoPanel(type){
    let show='none';
    if(type=='Uploadnow'){
     show='';
    }else{
      Common.message("",'Please upload your photo in few days','info');
    }

    this.setState({
     photoDisplay:show,
     optphotoOption:type

    });
  }

  getcountrycodes(){
   fetch(Config.domainUrl +"getcountrycodes", {
    method: "GET",
    headers: {
     'Accept': 'application/json',
     'Content-Type': 'application/json'
    }
   }).then((response) => response.json()).then((responseJson) => {
    this.setState({getcountrycodes:responseJson.country_data});
   });
  }

  getlocations_cities(){
   fetch(Config.domainUrl +"getlocationscities", {
    method: "GET",
    headers: {
     'Accept': 'application/json',
     'Content-Type': 'application/json'
    }
   }).then((response) => response.json()).then((responseJson) => {
    this.setState({
     locations:responseJson.location,
     cities:responseJson.city
    });
   });
  }



  fnOccupation(Occupation) {
     this.occupation(Occupation);

    	if(Occupation==1) {

      this.setState({
       hidOccupation:1,
       tr_student:'',
       tr_Working:'none',
       othershow:'none'
      });
    	} else if(Occupation==2) {
      this.setState({
       hidOccupation:2,
       tr_student:'none',
       tr_Working:'',
       othershow:'none'
      });
    	} else if(Occupation==3) {
       this.setState({
        hidOccupation:3,
        tr_student:'none',
        tr_Working:'none',
        othershow:''
       });
    	}
  }

  gender(value){
    this.setState({checkedGenderOption:value});
  }

  occupation(value){
    this.setState({checkedOccupationOption:value});
  }

  clearForm(e){


     $('form#registration_details')[0].reset();
     this.setState({
      photoDisplay:'none'

     });

  }

  handleChange(e){
    this.props.onClick(e);
  }
  componentDidMount() {
   this.getcountrycodes();
   this.getlocations_cities();
   setTimeout(function(){
    $("#txtdob").datepicker({
     dateFormat: 'D, d M, yy' ,
     changeMonth: true,
     changeYear: true,
     yearRange: "-70:-15",
     maxDate:'15Y'
    });
    jQuery('#semana-scroll-register').tinyscrollbar();
   },100);

  }

  render() {
   const {data} =this.props;
   const contryCodeoptions=this.state.getcountrycodes.map((key,index)=>
   <option key={index} value={key.id}>{key.name_code}</option>
   );

   const contryoptions=this.state.getcountrycodes.map((key,index)=>
   <option key={index} value={key.id}>{key.name}</option>
   );

   const locations=this.state.locations.map((key,index)=>
   <option key={index} value={key.name}>{key.name}</option>
   );

   const cities=this.state.cities.map((key,index)=>
   <option key={index} value={key.name}>{key.name}</option>
   );

    return (
       <div>
       <form id="registration_details">
       <input type="hidden" name="learner_id" value={data.learner_id_pk}/>
         <input type="hidden" name="app_code" value={(data.app_code)}/>
         <h1>PIN Registration</h1>
         Please fill in the following details to complete PIN Registration. All fields are mandatory to fill.
         <div className="gray-box-reg">
          {/* id="semana-scroll-register" className="scrollbar1"*/}
           <section >

             <section className="scrollbar">
               <section className="track">
                 <section className="thumb"></section>
               </section>
             </section>
             <section className="viewport">
               <section className="overview">
                 <div className="frm">
                   <div className="frm-left">
                     <div className="frm-left-txt">Customer Name</div>
                     <div className="frm-right-txt">
                       <span className="regdetspan"><strong>{data.corporate_name}</strong></span>
                     </div>
                   </div>
                   <div className="frm-right">
                     <div className="frm-left-txt">Email (Username)</div>
                     <div className="frm-right-txt">
                       <span className="regdetspan"><strong>{data.primaryemail}</strong></span>
                     </div>
                   </div>
                   <div className="clear"></div>
                   <div className="frm-left">
                     <div className="frm-left-txt">First Name  </div>
                     <div className="frm-right-txt">
                       <span className="regdetspan"  style={{'height':'36px'}} ><strong>{data.firstname}</strong></span>
                     </div>
                   </div>
                   <div className="frm-right">
                     <div className="frm-left-txt">Last Name </div>
                     <div className="frm-right-txt">
                       <span className="regdetspan" style={{'height':'36px'}}><strong>{data.lastname}</strong></span>
                     </div>
                   </div>
                   <div className="clear"></div>
                   <div className="frm-left">
                     <div className="frm-left-txt">Gender <span className="txt-red">*</span> </div>
                     <div className="frm-right-txt">
                       <div className="radio-box">
                        <input name="optgender" type="radio" value="1" checked={this.state.checkedGenderOption==1} onChange={e=>this.gender(1)} />

                         Male &nbsp;  &nbsp;
                         <input name="optgender" type="radio" value="2" checked={this.state.checkedGenderOption==2} onChange={e=>this.gender(2)} />
                         Female </div>
                     </div>
                     <div className="frm-left-txt">Date of Birth <span className="txt-red">*</span> </div>
                     <div className="frm-right-txt">
                     <input type="text" name="txtdob" className="txtdob" placeholder="Select Date" id="txtdob" readOnly />

                     </div>
                   </div>


                   <div className="frm-right">
                     <div className="frm-left-txt">Mobile No <span className="txt-red">*</span> </div>
                     <div className="frm-right-txt">
                       <select name="txtcountrycode" id="txtcountrycode">
                         <option value="">Select Country Code</option>
                         {contryCodeoptions}
                       </select>
                       {/*<span className="small-txt">Country Code</span>*/} <br/>
                       <input type="text" name="txtmobile" className="txtbox" maxLength="10" />
                       <span className="small-txt">10 digit Mobile Number</span><br/>
                     </div>
                   </div>
                   <div className="frm-left">
                     <div className="frm-left-txt">Occupation <span className="txt-red">*</span>
                        </div>
                     <div className="frm-right-txt">
                       <div className="radio-box">
                         <input name="rdoOccupation" type="radio" value="1" onChange={e=>this.fnOccupation(1)} checked={this.state.checkedOccupationOption==1} />
                         Student &nbsp;
                         <input name="rdoOccupation" type="radio" value="2" onChange={e=>this.fnOccupation(2)} checked={this.state.checkedOccupationOption==2} />
                         Working &nbsp;
                         <input name="rdoOccupation" type="radio" value="3" onChange={e=>this.fnOccupation(3)} checked={this.state.checkedOccupationOption==3} />
                         Other
                         <input type="hidden" name="hidOccupation" id="hidOccupation" value={this.state.hidOccupation}  />
                         </div>

                     </div>
                   </div>
                   <div className="clear"></div>
                   <div className="frm-full">

                     <div id="tr_student" style={{display:this.state.tr_student}}>
                       <div className="frm-left">
                         <div className="frm-left-txt">Dept of study <span className="txt-red">*</span></div>
                         <div className="frm-right-txt">
                           <input name="st_Studying" type="text" />

                         </div>
                       </div>
                       <div className="frm-right">
                         <div className="frm-left-txt">Year of study <span className="txt-red">*</span> </div>
                         <div className="frm-right-txt">
                           <select name="st_cmbYearofstudy" id="st_cmbYearofstudy">
                             <option value="">-- Select --</option>
                             <option value="1">I</option>
                             <option value="2">II</option>
                             <option value="3">III</option>
                             <option value="4">IV</option>
                           </select>

                         </div>
                       </div>
                       <div className="clear"></div>
                       <div className="frm-left">
                         <div className="frm-left-txt">College <span className="txt-red">*</span></div>
                         <div className="frm-right-txt">
                           <input type="text" name="st_College"  id="st_College" />

                         </div>
                       </div>
                       <div className="frm-right">
                         <div className="frm-left-txt">College Location <span className="txt-red">*</span> </div>
                         <div className="frm-right-txt">

                         {data.product=="232" || data.product=="231" ?
                          <select name="st_college_loc">
                          <option>Select</option>
                          {locations}
                          </select>:
                          <input name="st_college_loc"  type="text" />
                         }


                         </div>
                       </div>
                       <div className="clear"></div>
                     </div>
                     <div id="tr_Working" style={{display:this.state.tr_Working}}>
                       <div className="frm-left">
                         <div className="frm-left-txt">Designation<span className="txt-red">*</span> </div>
                         <div className="frm-right-txt">
                           <input name="wor_designation" type="text"/>

                         </div>
                       </div>
                       <div className="frm-right">
                         <div className="frm-left-txt">Experience <span className="txt-red">*</span></div>
                         <div className="frm-right-txt"> <span className="exp-yrs">
                           <select name="wor_lstexpyrs" id="wor_lstexpyrs" style={{width:"60%"}} defaultValue="0">
                             <option value="0" >0</option>
                             <option value="1" >1</option>
                             <option value="2" >2</option>
                             <option value="3" >3</option>
                             <option value="4" >4</option>
                             <option value="5" >5</option>
                             <option value="6" >6</option>
                             <option value="7" >7</option>
                             <option value="8" >8</option>
                             <option value="9" >9</option>
                             <option value="10" >10</option>
                             <option value="11" >11</option>
                             <option value="12" >12</option>
                             <option value="13" >13</option>
                             <option value="14" >14</option>
                             <option value="15" >15</option>
                             <option value="16" >16</option>
                             <option value="17" >17</option>
                             <option value="18" >18</option>
                             <option value="19" >19</option>
                             <option value="20" >20</option>
                             <option value="21" >21</option>
                             <option value="22" >22</option>
                             <option value="23" >23</option>
                             <option value="24" >24</option>
                             <option value="25" >25</option>
                           </select>
                           Years</span> <span className="exp-months">
                           <select name="wor_lstexpmonths" id="wor_lstexpmonths" style={{width:"60%"}} defaultValue="0">
                             <option value="0" >0</option>
                             <option value="1" >1</option>
                             <option value="2" >2</option>
                             <option value="3" >3</option>
                             <option value="4" >4</option>
                             <option value="5" >5</option>
                             <option value="6" >6</option>
                             <option value="7" >7</option>
                             <option value="8" >8</option>
                             <option value="9" >9</option>
                             <option value="10" >10</option>
                             <option value="11" >11</option>
                           </select>
                           <span style={{paddingTop:"13px",display:"inline-block"}}>Months</span></span>

                         </div>
                       </div>
                       <div className="clear"></div>
                       <div className="frm-left">
                         <div className="frm-left-txt">Education<span className="txt-red">*</span> </div>
                         <div className="frm-right-txt">
                           <input type="text" name="wor_Education"/>

                         </div>
                       </div>
                       <div className="frm-right">
                         <div className="frm-left-txt">Office Location <span className="txt-red">*</span></div>
                         <div className="frm-right-txt">

                         {data.product=="232" || data.product=="231" ?
                          <select name="wor_office_Location">
                          <option>Select</option>
                          {locations}
                          </select>:
                          <input name="wor_office_Location"  type="text" />
                         }

                         </div>
                       </div>
                       <div className="clear"></div>
                     </div>
                     <div id="othershow" style={{display:this.state.othershow}}>
                       <div className="frm-left">
                         <div className="frm-left-txt">Others Type <span className="txt-red">*</span> </div>
                         <div className="frm-right-txt">
                           <input name="oth_others"  type="text" />

                         </div>
                       </div>
                       <div className="frm-right">
                         <div className="frm-left-txt">Location <span className="txt-red">*</span> </div>
                         <div className="frm-right-txt">

                         {data.product=="232" || data.product=="231" ?
                          <select name="oth_rLocation">
                          <option>Select</option>
                          {locations}
                          </select>:
                          <input name="oth_rLocation"  type="text" />
                         }

                         </div>
                       </div>
                       <div className="clear"></div>
                     </div>
                   </div>

                   <div className="frm-left">
                     <div className="frm-left-txt">City / Town <span className="txt-red">*</span></div>
                     <div className="frm-right-txt">

                     {data.product=="232" || data.product=="231" ?
                      <select name="com_CityTown">
                      <option>Select</option>
                      {cities}
                      </select>:
                      <input name="com_CityTown"  type="text" />
                     }

                     </div>
                   </div>
                   <div className="frm-right">
                     <div className="frm-left-txt">Region / State <span className="txt-red">*</span> </div>
                     <div className="frm-right-txt">
                       <input name="com_RegionState" type="text"/>

                     </div>
                   </div>
                   <div className="clear"></div>
                   <div className="frm-left">
                     <div className="frm-left-txt">Country <span className="txt-red">*</span></div>
                     <div className="frm-right-txt">
                       <select name="com_cmbCountry" id="com_cmbCountry" >
                         <option value=''>Select</option>
                         {contryoptions}
                       </select>
                       <br/>

                     </div>
                   </div>
                   <div className="clear"></div>
                   <div className="frm-left-large"> Any other info about Me <span className="txt-red">*</span>
                     <textarea name="txtaboutyourself" id="txtaboutyourself" className="textarea word-count-check" onKeyUp={(e)=>countWords(e)} data-total-words="200"></textarea>
                     <div className="max-words">
                         <span className="date_red lefttxt">
                             Max words: 200
                         </span>
                     </div>
                     <div className="word-count">
                         <span className="balance-words" style={{float:'right'}}></span>
                         <span className="typing-words" style={{visibility:'hidden'}} ></span>
                     </div>
                    <br/>
                        </div>
                     <div className="clear"></div>
                     <div className="photo-box">

                       Please upload a photo of yours. It is required for the purpose of this programme. You can choose to upload it now or later.
                       <div className="clear"></div>
                       <div className="frm-left-photo">
                         <div className="frm-left-txt">Upload photo</div>
                         <div className="frm-right-txt">
                           <div className="radio-box">
                             <input type="radio" name="optphoto" className="rdbtn" id="optphoto" value="Uploadnow" checked={this.state.optphotoOption=='Uploadnow'} onChange={e=>this.showPhotoPanel('Uploadnow')}   />
                             now &nbsp;&nbsp;
                             <input type="radio" className="rdbtn" name="optphoto" id="optphoto" value="Uploadlater"  checked={this.state.optphotoOption=='Uploadlater'} onChange={e=>this.showPhotoPanel('Uploadlater')} />
                             later </div>

                         </div>
                       </div>
                       <div className="clear"></div>
                       <div className="frm-left-photo" id="photo" style={{display:this.state.photoDisplay}}>
                         <div className="frm-left-txt">Photo</div>
                         <div className="frm-right-txt dynImgText">
                            <input type="file" id="txtfile" size="96" accept="image/*" className="txtbox" name="txtfile" />
                           <span className="dynImg"><img id="blah" src="#" alt="your image" /></span> <span className="txtsmall">Preferred size up to 500KB. Maximum upload size is 2MB. ( Only JPEG,GIF Format ) </span>
                           <input name="hidfilename" type="hidden" id="hidfilename" value="" />


                         </div>
                       </div>
                     </div>

                     <div className="clear"></div>
                     <br/>
                     <div><span className="txt-red">*</span> Required fields</div>
                     <center>
                       <input type="button" onClick={(e)=>this.submit()}  name="btnsubmit" value={this.props.buttonText} className="btn-green" alt={this.props.buttonText} title={this.props.buttonText}/>
                       &nbsp;
                       <input type="button" name="btnsubmit" onClick={(e)=>this.clearForm()} value="Cancel" alt="Cancel" title="Cancel" className="btn-red"/>
                     </center>
                     <p id="add_height" style={{height:"50px"}}></p>
                   </div>
                   </section>
                   </section>
                   </section>
                 </div>
                 </form>
              </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/auth/Registeruserdetails.js